import { render, staticRenderFns } from "./TabelaGuiaTermos.vue?vue&type=template&id=0f861b9e&"
import script from "./TabelaGuiaTermos.vue?vue&type=script&lang=js&"
export * from "./TabelaGuiaTermos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports